import store from '@/store';
function isDesktopApp() {
  // Renderer process
  if (typeof window !== 'undefined' && typeof window.process === 'object' && window.process.type === 'renderer') {
      return true;
  }

  // Main process
  if (typeof process !== 'undefined' && typeof process.versions === 'object' && !!process.versions.electron) {
      return true;
  }

  // Detect the user agent when the `nodeIntegration` option is set to true
  if (typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0) {
      return true;
  }

  return false;
}
export default {
  printer(data, printerServerAddress, { interactive = true } = {}) {
    if (isDesktopApp()) {
      console.log('Printing from desktop app', data, printerServerAddress);
      const version = window.server.getAppVersion();
      // <= 1.0.0 always use intercept
      if (version.major >= 1 && version.minor >= 1) {
        console.log('Printing using event emitter');
        return window.server.printData({ printer: data.printerAddress, data: data.data });
      }
      console.log('Printing using fetch');
    }
    return fetch(`https://${printerServerAddress}`, {
      credentials: 'omit',
      headers: { accept: 'application/json, text/plain, */*', 'content-type': 'application/json', 'sec-fetch-dest': 'empty' },
      referrerPolicy: 'no-referrer-when-downgrade',
      body: JSON.stringify(data),
      method: 'POST',
      mode: 'no-cors',
    }).catch((e) => {
      if (!interactive) throw e;
      if (e.message.search('Failed to fetch') !== 1) {
        store.commit('setMessageModal', 'Switch to the newly opened tab. Click "Advanced" then continue to click "Proceed to xxx.xxx.xxx.xxx (unsafe)". Finally, Reprint');
        setTimeout(() => {
          window.open(`https://${printerServerAddress}`, '_blank');
        }, 2000);
      }
    });
  },
};